module.exports = __webpack_public_path__ + "static/media/agency.4acc3055.jpeg";